import { createAction, props } from '@ngrx/store';
import { SmartApp } from '../../core/models/smart-app.model';

export const getSmartApps = createAction('[SmartApp] Get SmartApps');

export const getSmartAppsSuccess = createAction(
  '[SmartApp] Get SmartApps Success',
  props<{ smartApps: SmartApp[] }>()
);

export const getSmartAppsFailure = createAction(
  '[SmartApp] Get SmartApps Failure',
  props<{ error: any }>()
);
